module.exports = __webpack_public_path__ + "img/bage1.e9e875c4.png";